import { render, staticRenderFns } from "./RemitaResponse.vue?vue&type=template&id=2d614b37&"
import script from "./RemitaResponse.vue?vue&type=script&lang=js&"
export * from "./RemitaResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports